<!--
  --
  -- 支払方法選択シート
  --
  -->
<template>
  <div class="mx-n4">
    <!-- 支払方法一覧 -->
    <v-list>
      <v-list-item-group
        mandatory
        :value="value"
        @change="$emit('change', $event)"
        color="primary"
      >
        <template
          v-for="(pay, index) in payments"
        >
          <v-divider
            v-if="index > 0"
            :key="`divider:${pay.payID}`"
          />

          <c-payment-item
            :key="`item:${pay.payID}`"
            :pay="pay"
            :active="value === pay.payID"
          />
        </template>
      </v-list-item-group>
    </v-list>
  </div>
</template>

<script>
import CPaymentItem from './CPaymentItem'

export default {
  name: 'CPaymentSheet',
  components: {
    CPaymentItem
  },

  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Number
    },
    payments: {
      type: Array,
      required: true
    }
  }
}
</script>
